import { Stack } from '@mui/material'
import React from 'react'
import { ControlledDto } from 'src/Libs/flow/installation/api'
import { AdvancedEvseSettings, AccessControl, LockCable, LedIntensity, OfflineBehaviour } from '../components'
import { useChargingStation } from '../hooks'
import { EvChargingPriority } from '../components/chargingPriority'
import { BlankView, BlankViewImageVariants } from 'src/Components/blank-view'
import { BannerLocations, BannerQueue } from 'src/Libs/banners'
import { Breadcrumb } from '@e3dc-react/shell/Elements/Header/Breadcrumbs'

type ChargingStationPageProps = {
  installationId: number
  pairedEvses: Nullable<ControlledDto>[]
  devicesAreLoading: boolean
  isSinglePhase: boolean
  storageId: string
  parentBreadcrumb: Breadcrumb
}

/**
 * The wallbox page of an installation's (user-level) settings.
 * Displays tabs for each wallbox and accordion sections for settings.
 */
export const WallboxPage: React.FC<ChargingStationPageProps> = ({
  installationId,
  pairedEvses,
  devicesAreLoading,
  isSinglePhase,
  storageId,
  parentBreadcrumb,
}) => {
  const { currentEvse, isModbusTcp, modbusTcpEvse } = useChargingStation({
    pairedEvses,
    installationId: installationId.toString(),
    storageId,
    parentBreadcrumb,
  })

  if (!currentEvse && !devicesAreLoading) {
    return (
      <BlankView
        title={'systemSettings.wallbox.no-active-device.title'}
        explanation={'systemSettings.wallbox.no-active-device.explanation'}
        imageVariant={BlankViewImageVariants.Worried}
      />
    )
  }

  return (
    <>
      <BannerQueue location={BannerLocations.FlowSettingsWallbox} sx={{ mb: 2, mt: [2, 0] }} />
      <Stack sx={{ width: '100%' }}>
        <EvChargingPriority installationId={installationId} evse={currentEvse} queryIsLoading={devicesAreLoading} />

        {isModbusTcp && modbusTcpEvse && (
          <>
            <AccessControl installationId={installationId} evse={modbusTcpEvse} queryIsLoading={devicesAreLoading} storageId={storageId} />
            <LockCable installationId={installationId} evse={modbusTcpEvse} queryIsLoading={devicesAreLoading} />
            <LedIntensity installationId={installationId} evse={modbusTcpEvse} queryIsLoading={devicesAreLoading} />
            <OfflineBehaviour installationId={installationId} evse={modbusTcpEvse} queryIsLoading={devicesAreLoading} />
          </>
        )}

        <AdvancedEvseSettings installationId={installationId} evse={currentEvse} queryIsLoading={devicesAreLoading} isSinglePhase={isSinglePhase} />
      </Stack>
    </>
  )
}
